<app-servicebanner
  heading="Comprehensive QA Services for Flawless Software Performance"
  paragraph="Pro Web delivers robust software quality assurance services, ensuring reliability and functionality. Our offerings include manual testing and automated solutions, providing top-tier QA for flawless user experiences."
  bannerimg="assets/img/servicesdev/webdesignbg.webp"
  mobileImg="QA_mobile.png"
  [cards]="logo"
  [cards2]="logo2"
  [tagline]="taglinearr"
></app-servicebanner>

<!-- breadcrumbs -->
<nav aria-label="breadcrumb" class="ps-5 pt-3 pt-md-0 d-none d-md-block">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="/">Home</a></li>
    <li class="breadcrumb-item"><a href="/">Services</a></li>
    <li class="breadcrumb-item active" aria-current="page">Quality Assurance</li>
  </ol>
</nav>

<app-technology-stack
  firsttitle="Delivering Core"
  semititle="Quality Assurance and Testing"
  description="Pro Web specializes in essential software quality assurance and testing services, ensuring software meets project requirements and exceeds user expectations. We provide comprehensive QA solutions to streamline software delivery and expedite release timelines. With deep expertise across diverse sectors including Healthcare, FinTech, Real Estate, Cybersecurity, Retail, and AdTech, we leverage integrated approaches and industry best practices to deliver complex, high-quality solutions"
  [cards]="cardsItems"
></app-technology-stack>

<section class="gradientwrap">
  <div>
    <div
      class="d-none d-md-flex justify-content-between align-items-center py-3 px-5"
    >
      <div class="contentIcon">
        <div class="d-flex align-items-center">
          <img src="assets/img/servicesdev/grad-one.png" alt="" srcset="" />
          <p class="text-white ps-2">Host In Dubai, UAE Data Center</p>
        </div>
      </div>
      <div class="px-3 d-none d-md-block">
        <img src="assets/img/servicesdev/white-diamond.svg" alt="" srcset="" />
      </div>
      <div class="contentIcon">
        <div class="d-flex align-items-center">
          <img src="assets/img/servicesdev/grad-two.png" alt="" srcset="" />
          <p class="text-white ps-2">20x Faster Speed</p>
        </div>
      </div>

      <div class="px-3 d-none d-md-block">
        <img src="assets/img/servicesdev/white-diamond.svg" alt="" srcset="" />
      </div>

      <div class="contentIcon">
        <div class="d-flex align-items-center">
          <img src="assets/img/servicesdev/grad-three.png" alt="" srcset="" />
          <p class="text-white ps-2">Dedicated Support</p>
        </div>
      </div>

      <div class="px-3 d-none d-md-block">
        <img src="assets/img/servicesdev/white-diamond.svg" alt="" srcset="" />
      </div>
      <div class="contentIcon">
        <div class="d-flex align-items-center">
          <img
            src="assets/img/servicesdev/firewall-icon.png"
            alt=""
            srcset=""
          />
          <p class="text-white ps-2">Rank Higher In Search Engine</p>
        </div>
      </div>
      <div class="px-3 d-none d-md-block">
        <img src="assets/img/servicesdev/white-diamond.svg" alt="" srcset="" />
      </div>
      <div class="contentIcon">
        <div class="d-flex align-items-center">
          <img src="assets/img/servicesdev/country-data.png" alt="" srcset="" />
          <p class="text-white ps-2">In Country Data Compliance</p>
        </div>
      </div>
    </div>
    <div
      class="d-block d-md-none justify-content-center align-items-center py-3"
    >
      <ngx-slick-carousel
        class="carousel owl-carousel branflex"
        [config]="carouselConfig2"
      >
        <div
          class="contentIcon"
          ngxSlickItem
          *ngFor="let item of iconsdata"
          class="slider-inlinefixe"
        >
          <div class="text-center">
            <img src="{{ item.icon }}" class="m-auto" alt="icon" srcset="" />

            <p class="text-white my-2" style="font-size: 12px">
              {{ item.name }}
            </p>
          </div>
        </div>
      </ngx-slick-carousel>
    </div>
  </div>
</section>

<app-dedicated-hosting
  heading="QA and Software"
  subheading="Testing Features"
  [data]="dataItems"
></app-dedicated-hosting>

<section class="vapt">
  <div class="container">
    <div class="row align-items-center gy-4">
      <div class="col-md-6">
        <h2 class="my-3 fw-bold">Penetration Testing Services (VAPT)</h2>
        <div class="text-end d-block d-md-none my-4">
          <img
            src="../../assets/img/servicesdev/quality-assurance/vapt_img.png"
            alt="vapt"
            srcset=""
          />
        </div>
        <p>
          Pro Web offers top-tier Penetration Testing Services (Vulnerability
          Assessment and Penetration Testing - VAPT) to secure your digital
          assets against potential threats. Our expert team conducts rigorous
          assessments to uncover vulnerabilities within your IT infrastructure,
          applications, and networks. By simulating real-world attacks, we
          identify security gaps and provide actionable insights to strengthen
          your defenses. Serving diverse industries, our VAPT services ensure
          regulatory compliance and enhance overall security, safeguarding your
          business from cyber threats.
        </p>

        <div>
          <button class="showbtn">
            <a href="/vapt-testing/dubai"
              >explore VAPT
              <img
                src="../../assets/img/servicesdev/service-arrow.svg"
                class="px-2 d-none d-md-inline-block"
                alt="arrow"
                srcset=""
            /></a>
          </button>
        </div>
      </div>
      <div class="col-md-6">
        <div class="text-end d-none d-md-block">
          <img
            src="../../assets/img/servicesdev/quality-assurance/vapt_img.png"
            alt="vapt"
            srcset=""
          />
        </div>
      </div>
    </div>
  </div>
</section>

<app-testimonial-service profile="harvey-profile.png" clientname="Harvey Liptrot"
designation="Managing Director, Springboard Supplies LTD" location="United Arab Emirates" flag="uk-flag.svg"
clientcomment="Our experience with Rohit and his team has exceeded our expectations. The scope of work offered was flexible and tailored to suit our specific needs. Other IT companies said it would not be possible but Pro Web have made it work. Arshad and Manoj responded quickly to update the project based on feedback and all communication was handled seamlessly by Shrishti. We are glad to have found Pro Web and look forward to working with them on further projects with our other businesses in the future. Thank you for your dedication and commitment to the project!"
rating="Rated 4.9 out of 5.0" [clientimg]="data" [clientmobile]="datamobile"
clienttarget="The_travel_hub_logo.svg"></app-testimonial-service>

<!-- the proweb way section -->

<section class="spacing">
  <div class="proweb-padding">
    <div class="row justify-content-center processWrap">
      <h2 class="my-3">The <span>Pro Web Way</span></h2>
      <p>
        Being a reputed cloud deployment service provider, we have a streamlined
        process to develop cloud infrastructure and migration for your business
        IT infrastructure.
      </p>
      <div class="d-none d-md-flex p-3">
        <div class="row px-5">
          <div class="col">
            <div class="cardwrap">
              <div class="text-start p-3">
                <div class="d-flex">
                  <img
                    src="../../assets/img/servicesdev/process-way/analysis-gray.png"
                    class="gray"
                    alt=""
                    srcset=""
                  />
                  <img
                    src="../../assets/img/servicesdev/process-way/analysis-orange.png"
                    class="orange"
                    alt=""
                    srcset=""
                  />

                  <img
                    src="../../assets/img/servicesdev/straight-arrow2.svg"
                    class="top-arrow"
                    alt=""
                    srcset=""
                  />
                </div>
              </div>
              <div class="cardcontent">
                <h5 class="text-start fw-bold">Prepare Test Strategy</h5>
                <ul>
                  <li>Understand the project scope and functionality</li>
                  <li>Define clear testing goals and expected outcomes</li>
                  <li>
                    Select the best testing approach for comprehensive coverage
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="cardwrap">
              <div class="text-start p-3">
                <div class="d-flex">
                  <img
                    src="../../assets/img/servicesdev/process-way/design-gray.png"
                    class="gray"
                    alt=""
                    srcset=""
                  />

                  <img
                    src="../../assets/img/servicesdev/process-way/design-orange.png"
                    class="orange"
                    alt=""
                    srcset=""
                  />

                  <img
                    src="../../assets/img/servicesdev/straight-arrow2.svg"
                    class="top-arrow"
                    alt=""
                    srcset=""
                  />
                </div>
              </div>
              <div class="cardcontent">
                <h5 class="text-start fw-bold">List Test Cases</h5>
                <ul>
                  <li>List crucial actions and scenarios to test</li>
                  <li>
                    Create or revise test cases based on current project needs
                  </li>
                  <li>Ensure test cases cover all quality aspects</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="cardwrap">
              <div class="text-start p-3">
                <div class="d-flex">
                  <img
                    src="../../assets/img/servicesdev/process-way/quality-gray.png"
                    class="gray"
                    alt=""
                    srcset=""
                  />

                  <img
                    src="../../assets/img/servicesdev/process-way/quality-orange.png"
                    class="orange"
                    alt=""
                    srcset=""
                  />

                  <img
                    src="../../assets/img/servicesdev/straight-arrow2.svg"
                    class="top-arrow"
                    alt=""
                    srcset=""
                  />
                </div>
              </div>
              <div class="cardcontent">
                <h5 class="text-start fw-bold">Execute Test Cases</h5>
                <ul>
                  <li>Design tests for functionality and UI</li>
                  <li>Create detailed checklists for systematic testing</li>
                  <li>Execute tests to identify issues</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="cardwrap">
              <div class="text-start p-3">
                <div class="d-flex">
                  <img
                    src="../../assets/img/servicesdev/process-way/deploy-gray.png"
                    class="gray"
                    alt=""
                    srcset=""
                  />

                  <img
                    src="../../assets/img/servicesdev/process-way/deploy-orange.png"
                    class="orange"
                    alt=""
                    srcset=""
                  />
                </div>
              </div>
              <div class="cardcontent">
                <h5 class="text-start fw-bold">Present Test Results</h5>
                <ul>
                  <li>Prepare clear, detailed reports of test results</li>
                  <li>Clearly describe identified problems and their impact</li>
                  <li>Provide updates on issue resolution progres</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-block d-md-none my-4">
        <ngx-slick-carousel
          class="carousel owl-carousel branflex processSlider"
          [config]="carouselConfig"
        >
          <div class="cardwrap" ngxSlickItem class="slider-inlinefixe">
            <div class="cardcontent">
              <div class="text-center p-3">
                <img
                  src="/assets/img/servicesdev/process-way/analysis-orange.png"
                  class="orange"
                  alt=""
                  srcset=""
                />
              </div>
              <h5 class="text-center fw-bold my-3">Prepare Test Strategy</h5>
              <ul>
                <li>Understand the project scope and functionality</li>
                <li>Define clear testing goals and expected outcomes</li>
                <li>
                  Select the best testing approach for comprehensive coverage
                </li>
              </ul>
            </div>
          </div>

          <div class="cardwrap" ngxSlickItem class="slider-inlinefixe">
            <div class="cardcontent">
              <div class="text-center p-3">
                <img
                  src="/assets/img/servicesdev/process-way/design-orange.png"
                  class="orange"
                  alt=""
                  srcset=""
                />
              </div>
              <h5 class="text-center fw-bold my-3">List Test Cases</h5>
              <ul>
                <li>List crucial actions and scenarios to test</li>
                <li>
                  Create or revise test cases based on current project needs
                </li>
                <li>Ensure test cases cover all quality aspects</li>
              </ul>
            </div>
          </div>

          <div class="cardwrap" ngxSlickItem class="slider-inlinefixe">
            <div class="cardcontent">
              <div class="text-center p-3">
                <img
                  src="/assets/img/servicesdev/process-way/quality-orange.png"
                  class="orange"
                  alt=""
                  srcset=""
                />
              </div>
              <h5 class="text-center fw-bold my-3">Execute Test Cases</h5>
              <ul>
                <li>Design tests for functionality and UI</li>
                <li>Create detailed checklists for systematic testing</li>
                <li>Execute tests to identify issues</li>
              </ul>
            </div>
          </div>

          <div class="cardwrap" ngxSlickItem class="slider-inlinefixe">
            <div class="cardcontent">
              <div class="text-center p-3">
                <img
                  src="/assets/img/servicesdev/process-way/deploy-orange.png"
                  class="orange"
                  alt=""
                  srcset=""
                />
              </div>
              <h5 class="text-center fw-bold my-3">Present Test Results</h5>
              <ul>
                <li>Prepare clear, detailed reports of test results</li>
                <li>Clearly describe identified problems and their impact</li>
                <li>Provide updates on issue resolution progres</li>
              </ul>
            </div>
          </div>
        </ngx-slick-carousel>
      </div>
    </div>
  </div>
</section>

<app-why-choose-proweb
  heading="Why Choose Pro Web As Your
  QA and software testing services?"
  desc="Our QA services will improve your control over the product life cycle, provide insight into the development process, and deliver accurate information on product quality."
  [obj]="cards"
></app-why-choose-proweb>

<app-bottom-bar
  text="Elevate your software quality with our cutting-edge QA solutions."
></app-bottom-bar>

<section class="spacing">
  <div class="container-md">
    <div class="row justify-content-center justify-content-md-start">
      <h2>Frequently <span>Asked Questions </span></h2>
      <p class="my-3">
        Our industry expertise and research capabilities drive our leadership in
        developing advanced engagement models.
      </p>

      <div class="row my-4">
        <div class="col-sm-6">
          <div
            class="faq-list"
            *ngFor="let item of faq.slice(0, 4); let i = index"
          >
            <div
              class="faq-title d-flex justify-content-between"
              (click)="toggleAccordian($event, i)"
            >
              <h6>{{ item.title }}</h6>

              <h4 *ngIf="item.isActive == false">+</h4>
              <h4 *ngIf="item.isActive == true">-</h4>
            </div>
            <div class="faq-des" *ngIf="item.isActive">
              <div [innerHTML]="item.des"></div>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div
            class="faq-list"
            *ngFor="let item of faq.slice(4); let i = index"
          >
            <div
              class="faq-title d-flex justify-content-between"
              (click)="toggleAccordian($event, i + 4)"
            >
              <h6>{{ item.title }}</h6>

              <h4 *ngIf="item.isActive == false">+</h4>
              <h4 *ngIf="item.isActive == true">-</h4>
            </div>
            <div class="faq-des" *ngIf="item.isActive">
              <div [innerHTML]="item.des"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
